<template>
    <div>
      <p class="ArticleNormal">
        短视频正在成为内容表达的标配“水电煤”。
      </p>
      <p class="ArticleNormal">
        为了厘清短视频传播对于城市品牌塑造的价值及路径，我们邀请到浙江省钱塘江文化研究会会长胡坚，中共湖州市委宣传部副部长、市委网信办主任陈建良，中共潮州市委常委、宣传部部长王文森，中共东莞市委宣传部常务副部长李翠青，中共什邡市委常委、宣传部部长向辉，象山县委常委、宣传部长应建勇等一线操盘手进行对话。他们以丰富经验，洞察出城市名片打造的窍门与方法论，同时也挖掘出更多借力短视频打造城市名片的创意思路。
      </p>
      <p class="ArticleNormal">
        *以下排名不分先后
      </p>
      <p class="ArticleHead">
        把握“天时、地利、人和”，打破千城一面
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">【胡坚 浙江省钱塘江文化研究会会长】</span>
      </p>
      <p class="ArticleNormal">
        世界城市的影响力，已经从经济能级到政治能级到今天的文化能级，文化对一个城市的影响越来越大。一句“上有天堂，下有苏杭”，让杭州千百年来成为城市形象传播的重要受益者。城市形象是指能够激发人们思想感情活动的城市形态和特征，是城市内部与外部公众对城市内在实力、外显活力和发展前景的具体感知、总体看法和综合评价。
      </p>
      <p class="ArticleNormal">
        可以说，城市形象既是城市综合性呈现的凝练，也是城市发展某一方面特质而外化的标志性符号。关键是要给人留下印象深刻，引发丰富联想，产生强烈共鸣。例如，近三年来，以弘扬“弄潮儿”精神为内核的钱塘江文化节举办了100多项系列活动，累计吸引国内外各界人士400多万人次参加，已经成为钱塘江流域影响很大的综合性文化活动。
      </p>
      <p class="ArticleNormal">
        期间，还举办了数十场产业交流、招商引才活动，成功引进德国设计委员会标志性设计奖大中华区运营中心、两岸文创IP协同创新中心、孟京辉导演工作室、王晓鹰导演工作室等一大批项目落地签约。这些都让城市精神和城市形象得到了很好的彰显。随着新媒体的兴起，尤其是短视频的出现，则为城市形象传播提供了更多的渠道与途径。
      </p>
      <p class="ArticleNormal">
        现在，我们在城市建设中存在一个比较普遍的问题就是“千城一面”，城市的推介方式也存在同样的问题。为此，如何借助短视频这一媒介，更好展示城市自己独特的气质和形象，是一个需要高度关注的问题。现在城市形象传播过程中，仍然存在对于“天时、地利、人和”的难以准确把握。包括是否对城市形象有准确定位，是否有一个“叫得响”的推广方案，有一个“传得开”的传播载体和“打得赢”的执行团队，为项目推进起到保驾护航作用。包括推广的时机是否合适也非常重要，只有抢抓机遇、顺势而为，才能实现事半功倍的效果。
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_3.jpg"/>
      <p class="ArticleNormal">
        为更好运用短视频助力城市形象传播，展现城市精神气质和文化底蕴，近几年，钱塘江文化建设已经探索打造了“文化研究、文化节展、文化创作、文化引领”四位一体模式，使之成为推动城市发展的重要引擎、展现城市魅力的创新方式。随着钱塘江古海塘申遗被提上议事日程，钱塘江文化建设也将进入大发展、大繁荣的重要阶段。接下来，需要继续发挥自身优势，坚持在“保护、传承、融合”上精准发力，高起点谋划、高标准推进古海塘遗址保护开发，以“弄潮儿”精神深入推进钱塘江文化建设，全力打造历史与现代交融的“重要窗口”的文化精彩样板。
      </p>
      <p class="ArticleNormal">
        但城市形象的传播并非一蹴而就，而是一个需要长期培育、积累、发展、提升的过程。
      </p>
      <p class="ArticleNormal">
        以杭州江干区为例，改革开放以前，通过对钱塘江围垦造田，树立起了杭城“菜篮子基地”的形象；改革开放以后，通过率先搏击市场经济大潮成了“市场大区”，鼎鼎大名的“中国服装第一街”四季青服装市场就坐落于江干；进入新世纪，杭州实施“城市东扩、沿江发展”战略，位于江干辖区内的钱江新城核心区快速崛起，成为城市发展新地标。2017年11月，杭州市委、市政府提出“拥江发展”战略，杭州正式从“西湖时代”迈入“钱塘江时代”，江干区由此成为“拥江发展”的主战场、城市发展的新中心。走进新时代，钱江新城新一期的开发将崛起一个崭新的城市窗口。
      </p>
      <p class="ArticleNormal">
        这一路走来，历史以有形和无形之笔描绘着城市形象的丰富魅力。而城市形象传播效果的好与不好，用“金杯银杯不如老百姓的口碑”这句话来形容，可能是最恰当不过。如果结合互联网时代的背景，那么，广大网友尤其是中青年群体和大学生群体的认可，就显得十分重要。因此，一个城市的创新创业活力程度，直接影响着城市形象的传播。进入短视频时代，如何通过多角度、多主题的短视频内容，“以小见大”，立体化、全方位地展现城市经济、政治、文化、社会、生态以及市容市貌、市民素质、社会秩序、历史文化等多维魅力，将成为传播的重要方面。
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_4.jpg"/>
      <p class="ArticleNormal">
        总之，我们在利用短视频传播文化与塑造城市形象上已经做了不少的探索，也取得了许多成绩。但是，形势发展非常快，技术手段的更新也非常快，需要我们再接再励，继续前行，以创新创造开辟出一个文化传播与城市发展的新天地。
      </p>
      <p class="ArticleHead">
        短视频助力擦亮城市金名片
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">【陈建良 中共湖州市委宣传部副部长、市委网信办主任】</span>
      </p>
      <p class="ArticleNormal">
        湖州是“绿水青山就是金山银山”理念的诞生地、“中国美丽乡村”的发源地，素有山水清远的“生态美”、古今交汇的“人文美”、秀外惠中的“形象美”、绿色制造的“产业美”、宜居乐活的“和谐美”，这些“各美其美、美美与共”的动人景象，契合着短视频传播的特点和受众对内容的需求，有效塑造着独具个性的城市名片，扩大了湖州的知名度和美誉度。
      </p>
      <p class="ArticleNormal">
        城市品牌传播需要政府部门的主导和引导，也需要社会公众的参与和互动，用多重视角共同拼接出城市新形象。以抖音、快手、小红书、哔哩哔哩为代表的短视频传播形态的出现，为城市形象宣传、城市名片打造提供了新的路径。
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_1.jpg"/>
      <p class="ArticleNormal">
        从湖州的传播实践看，我认为短视频的价值主要表现在三大方面：
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">一、扩大城市影响，打造易辨识有个性的城市品牌</span>
      </p>
      <p class="ArticleNormal">
        短视频以开放式、互动性和可视化的特点，用生活化、轻量化、时尚化的内容，迅速捕获了大量用户尤其是青年用户群体。选择风光美景、特色美食、历史人文等更有直观感受性的内容，利用短视频的方式传播城市品牌，可以突破传统主流媒体严肃庄重的宣传风格，增加亲切感和代入感，让城市形象更加立体化、多元化。
      </p>
      <p class="ArticleNormal">
        去年《在湖州看见美丽中国》城市形象片发布后，点击率超过6000余万次，“在湖州看见美丽中国”城市品牌影响力显著提升。今年疫情期间，《李兰娟院士来到湖州安吉》短视频在抖音推出，阅读量达到1029.9万，点赞量23.1万；《你笑起来真好看》阅读量947万，点赞量22.7万。今年以来，湖州利用“南太湖号”APP，借助新媒体平台，全年制作推出各类短视频296个，阅读量超过10万的短视频12个。短视频的应用，让受众对湖州形象有了进一步的认识。
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">二、优化受众结构，塑造低成本高品质的城市形象</span>
      </p>
      <p class="ArticleNormal">
        通过短视频的宣传方式，可以帮助城市迅速打通空间壁垒，彰显文化形象，塑造城市形象，提升公共形象，甚至可以形成自身独有的核心竞争力。
      </p>
      <p class="ArticleNormal">
        当前，湖州运用短视频塑造城市形象的优势，围绕建设新时代全面展示中国特色社会主义制度优越性的重要窗口示范样本的目标，深入实施五年百项千亿综合交通大会战，着力打造全国绿色制造名城，以“最多跑一次”改革撬动各领域改革，在全国率先出台了“湖8条”“湖9条”和人才新政4.0版等极具含金量的超常规政策。这些反映了新时代湖州发展的新理念和新目标的举措，是传播城市品牌过程中着重塑造的城市形象。
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">三、赋能经济发展，构造影响大动力强的发展引擎</span>
      </p>
      <p class="ArticleNormal">
        从目标导向来讲，运用短视频传播城市品牌，根本目的是提升城市影响力，为经济发展赋能。从湖州实践来看，有两个成功的案例。第一个：今年4月份，携程与湖州直播预售酒店，一小时中吸引了114万网友在线观看，总互动人次171万，销售额创纪录地达到2691万元。第二个，今年5月份，秦朔先生推出自媒体文章《在湖州体会中国治理：天下如你，百姓无忧》，一家上市企业老总阅读后，主动到湖州考察洽谈，并确定了投资项目。
      </p>
      <p class="ArticleNormal">
        可以说，短视频是城市形象传播的“利器”，湖州以“两山”转化推动高质量发展作为主要着力点，借助短视频这个载体向外界讲述城市故事、促进城市形象传播，进一步擦亮了 “在湖州看见美丽中国”金名片。
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_2.jpg"/>
      <p class="ArticleNormal">
        而面对如何评估短视频的传播效果这一难题，结合湖州的实践从单个短视频来说，传播效果可以通过阅读量、点赞量、热播度、热搜度、播赞比、播评比等数据进行量化评估。但从目标导向来讲，短视频能否提升城市影响力，转化为经济发展的推动力，需要达到三个效果：一是城市的对外知名度有所提升；二是社会对城市的认知与宣传导向保持一致；三是增强对项目、人才和游客的吸引力。
      </p>
      <p class="ArticleHead">
        短视频推动城市传播变革：政府搭台，民众唱戏
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">【李翠青 中共东莞市委宣传部常务副部长  】</span>
      </p>
      <p class="ArticleNormal">
        当前，短视频的兴起推动了传播的变革，让城市品牌传播从以政府为主体的单向宣传转变为以市民为主体的自发传播，呈现出“政府搭台，民众唱戏”的新格局。显然，短视频对于城市传播变革意义非凡。
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_5.jpg"/>
      <p class="ArticleNormal">
        首先，在传播主体上，短视频时代赋予了民众参与和自我表达路径，突破了传统传播者的单一性，普通市民都可以创作者、传播者乃至引领者身份加入传播链中，对城市进行更立体多元的表达，向外界呈现更鲜活、全面的城市印象。
      </p>
      <p class="ArticleNormal">
        其次，在传播内容和形式上，与图文以及传统城市形象宣传片相比，短视频内容上更多元，形式上更活泼，情感上更贴近，能够通过生活化、场景化、可视化的表达，传达更具烟火气、更有人情味的城市特质。
      </p>
      <p class="ArticleNormal">
        最后，在传播范围和效率上，短视频依托各大网络平台进行传播，打破了城市内容场景和地域限制，具有用户体量大、社交属性强等特点，可以在很短时间内实现裂变式传播，能产生更为广泛的城市品牌传播影响。
      </p>
      <p class="ArticleNormal">
        去年以来，东莞正式在短视频传播上发力，开通“东莞发布”账号，逐步搭建起官方和民间结合的短视频传播矩阵。截至今年8月，“东莞发布”抖音号累计发布原创短视频近700条，粉丝数102.5万，视频总播放量超8亿次，获赞数超1532万，成为展示东莞城市形象的重要窗口。去年男篮世界杯和亚洲马拉松赛事期间，东莞联合两家头部短视频平台，开展“最强莞篮”和“品质东莞DOU起来”短视频挑战赛，吸引了大量网络达人参与传播东莞，征集了近2万个视频，传播量近3亿，推动东莞成为人气爆棚的“网红”城市，有效对外传播了东莞的城市品牌形象。
      </p>
      <p class="ArticleNormal">
        东莞不仅是制造名城，也有着深厚的人文底蕴和多元的城市文化，“海纳百川，厚德务实”是东莞的城市精神。日前，同济大学发布的《2020年Q2中国城市活力研究报告》显示，在2020年Q2全国主要城市人口吸引力榜单中，东莞排名全国第三。这里外来人口多、年轻人多，有很多关于普通人的友善故事、包容故事、励志故事、追梦故事，相信都是短视频平台上非常受欢迎的题材。近日湖北籍务工者吴桂春与东莞图书馆的故事，也借助短视频的传播感动全国，展示出这座城市骨子里的友善、温暖和包容。
      </p>
      <p class="ArticleNormal">
        除此之外，东莞还有几个很有辨识度的符号，非常适合通过短视频来传播。
      </p>
      <p class="ArticleNormal">
        一是篮球城市。作为CBA十冠王广东宏远的所在地，篮球文化是东莞最闪亮的城市名片之一，篮球运动本身活力动感的特点，也非常适合通过视频传播。不久前独臂男孩张家城感动无数网友，短视频《广东宏远发出邀请！阿联朱芳雨盛赞！13岁独臂篮球少年爆红…》播放量达到1164.9万次。
      </p>
      <p class="ArticleNormal">
        二是东莞美食。地方美食是很容易获得关注的题材，近期网络热播的美食纪录片《寻味东莞》，相关短视频全网播放量超过1亿，受到了广大网友的喜爱和追捧。
      </p>
      <p class="ArticleNormal">
        三是东莞制造。先进制造业所蕴含的科技元素、文化质感乃至民族情感，也可以成为短视频传播的重要内容。
      </p>
      <p class="ArticleNormal">
        四是人文生态。东莞是岭南文明的重要发源地、中国近代史开篇地，有着丰富独特的历史人文资源，同时也是一座生态宜居之城，有很多适合短视频创作和传播的元素。
      </p>
      <p class="ArticleNormal">
        至于如何评估传播效果，我认为主要有三个维度：
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_6.jpg"/>
      <p class="ArticleNormal">
        一是传播力，具体表现为传播的热度，也就是短视频在各大平台的发布量、浏览量、点赞量、评论量、转发量等数据，这是传播效果最直观的评估维度。
      </p>
      <p class="ArticleNormal">
        二是感染力，短视频传播的基础是能够吸引人、打动人，好的短视频应该能让人沉浸其中并产生共鸣，让人印象深刻、触发情感体验。
      </p>
      <p class="ArticleNormal">
        三是影响力，从城市形象传播的角度，短视频让人对这座城市产生向往之情，乃至形成热点话题，引发名人关注、网民热议，甚至推动实体工作，就是有影响力的表现。
      </p>
      <p class="ArticleHead">
        能量正、切口小、创意好，短视频带来“三新”价值
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">【王文森 中共潮州市委常委、宣传部部长】</span>
      </p>
      <p class="ArticleNormal">
        潮州市位于粤港澳大湾区与海峡西岸经济区的交汇处，是海上丝绸之路的重要节点城市，素有“岭东首邑”“岭海名邦”“海滨邹鲁”的美誉，是历代郡、州、路、府的治所，潮文化的发祥地，世界潮人根祖地和精神家园。
      </p>
      <p class="ArticleNormal">
        潮州文化底蕴深厚，文物景点众多，其中有广济桥、开元寺、韩文公祠、牌坊街等国家重点文物保护单位9处；有国家级非物质文化遗产名录15项，潮州菜、潮剧、潮州音乐、潮州刺绣、潮州木雕等非物质文化享誉中外，文物古迹密集度和非物质文化遗产数量居广东省各地市首位。结合潮州的传播效实践，潮州几大特色文化非常适合以短视频传播：
      </p>
      <p class="ArticleNormal">
        潮州功夫茶：潮州工夫茶艺传承了唐宋茶文化遗风，有中国古代茶文化“活化石”之称，综观当今各地的茶艺茶道，以潮州工夫茶艺最为精致、著名。
      </p>
      <p class="ArticleNormal">
        潮州菜：潮州菜历史悠久，起源于唐代，发展于宋代，明代又进一步推陈出新，进入鼎盛时期；到了近现代，潮州菜已发展成为独具岭南文化特色、驰名海内外的名菜之一，在中国乃至世界烹饪文化中占据重要的位置。特色美食视频历来都是网络宠儿，2019年美食系列纪录片《风味原产地﹒潮汕》全网播放量达4亿，且成为Netflix采购的第一部中国原创美食纪录片，配置超过 20 种语言字幕并面向 190 多个国家和地区播出。
      </p>
      <p class="ArticleNormal">
        手工艺：潮州民间工艺美术历经一代又一代的传承、发展与推陈出新，凭着潮人的精品意识、精致追求，创造了具有地方特色的40多个工艺门类，荣获了国内唯一的“中国工艺美术之都”“中国瓷都”“中国民间工艺传承之都”等金字招牌。在网红“故宫”的潮流带动下，相信潮绣、金漆木雕、大吴泥塑等非遗手工艺微视频会引起网民的关注和传播。
      </p>
      <p class="ArticleNormal">
        关于短视频在城市品牌传播中的作用，则主要体现在“三新”：
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_7.jpg"/>
      <p class="ArticleNormal">
        一是展示城市形象的新机遇。自4G网络广泛应用以来，短视频凭借内容丰富、立体展现、个性表达、互动便捷等特点，迅速成为互联网最流行的传播形式，也成为传播城市品牌、传递正面能量、丰富城市内涵、促进旅游发展的新途径；随着5G网络时代的到来，相信短视频的传播方式、应用场景、语言内容会有更多的创新，受众覆盖面也会更加广泛，这是加强城市形象宣传力度，展示大美中国、大美潮州的一个新机遇。
      </p>
      <p class="ArticleNormal">
        二是推动城市对外传播的新动力。短视频因创作门槛低、易于分享传播，吸引了越来越多普通用户参与录制分享，其中大部分短视频平台用户在分享内容上都选择以所在城市、家乡的美食美景和新鲜事物为主，这意味着城市形象网络传播的力度在不断加强，城市品牌传播的主体从原来的政府主导逐步转变成政府和民间共同参与，短视频的语言、内容等表达形式也变得更丰富、更亲切；大众的创新思维、创造能力被深度激发，转化成为城市品牌传播源源不断的新动力。
      </p>
      <p class="ArticleNormal">
        三是促进城市发展的新经济。短视频是继图文、纪录片、直播之后的又一个流量洼地，其带来的最直接效应就是拉动文旅产业经济的增长，推动文旅企业的转型升级；同时也促进了中华优秀传统文化对于年轻群体的传播，促使了年轻群体积极主动去了解、学习、分享中华文化，进而带动了年轻中产阶层对具有传统文化基因、城市品牌特色的新国货的消费热情。这种新的业态，可以说是催生了一种“年轻中产消费反哺城市品牌文化传播”的新经济现象。
      </p>
      <p class="ArticleNormal">
        而短视频的效果评估可以用三个词归纳：
      </p>
      <p class="ArticleNormal">
        能量正。能够引发广大网民点赞转发的短视频，大部分都是正能量充盈、有情感共鸣的。例如2019年2月“潮州小女孩过马路对礼让小车鞠躬”的短视频一经传播，点击量当天即破百万，数百万网友为小女孩点赞，更是引起人民日报等央媒新媒体平台的转发评论，充分展现了潮州这座城市的善意与温暖，也弘扬了中华民族的传统美德。
      </p>
      <p class="ArticleNormal">
        切口小。视频时长限制故事内容篇幅，因此，好的短视频应该善于用小切口反应新时代，比如通过呈现每一个小家庭的变化，反映人民对美好生活的向往，折射国家的光辉历程和伟大成就，用网民喜闻乐见的形式，讲述个人、家庭与祖国共奋进、共成长、共命运的故事。
      </p>
      <p class="ArticleNormal">
        创意好。目前各大短视频平台上，许多视频内容同质化情况严重，“短暂网红”已是常态，其原因大都是视频内容缺乏创意、网民观众已审美疲劳。随着网络、技术的快速发展，短视频平台也开始在自我革新，内容乏味、形式陈旧的短视频将被时代淘汰。所以，创新创意应作为评估短视频的考量点。
      </p>
      <p class="ArticleHead">
        用短视频寻求突破，县级城市深耕特色
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">【 向辉 中共什邡市委常委、宣传部部长】</span>
      </p>
      <p class="ArticleNormal">
        短视频成为广大网友生活中不可缺少的一部分后，其在城市品牌传播方面的影响力不可小估。
      </p>
      <p class="ArticleNormal">
        就大城市、知名旅游地等具有基础知名度、影响力、吸引力的地方而言，短视频的二次传播进一步扩大了当地的城市品牌宣传作用，把当地在网民中的模糊印象提升到了一个或一些更具象的点上。比如，西安兵马俑知名度很高，短视频的二次传播把西安如回民街、钟楼等更多的元素具象化展示到网民面前。
      </p>
      <p class="ArticleNormal">
        就缺少基础知名度、吸引力的地方而言，情况或许有所不同。以县级城市什邡为例，短视频传播更像是在寻求突破，用一种更易于快速、大范围传播的方式来展示吸引力，提升城市品牌的知名度。总体而言，就是实现互为促进或单线突破，整体来看是积极的。
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_8.jpg"/>
      <p class="ArticleNormal">
        五千年的历史底蕴和丰富的自然、人文、产业资源，赋能什邡，让什邡集“中国民间文化艺术（书法）之乡”、“中国矿泉水之乡”、“中国雪茄之乡”、“马祖故里”等城市名片于一身。这里有蓥华山秀美无边，更有“西川佛都”罗汉寺、避暑胜地钟鼎寺、红峡谷、李冰导洛遗迹朱李火堰、亚洲最大的雪茄烟生产基地、中国唯一一座雪茄博物馆、中国西部最大的食品饮料生产基地……什邡地处成都半小时经济圈，曾连续13年跻身“四川省十强县”，多年来什邡坚持走新型工业化、城乡统筹发展之路，已成为一座宜商、宜居、宜业的产业新城，是西部投资热土和创业发展宝地。
      </p>
      <p class="ArticleNormal">
        什邡党委、政府早已意识到新媒体特别是短视频传播对城市品牌影响力提升的积极作用，在多次大型活动推介中尝试推出多条短视频。但坦率来讲，传播力、影响力和预期还有一定差距。
      </p>
      <p class="ArticleNormal">
        我认为未来什邡将加大力度挖掘城市文化资源的独特价值，通过短视频对城市的特色文化符号进行更具创意的营销，为受众提供新颖的体验并激发受众用短视频记录分享的兴趣。
      </p>
      <p class="ArticleNormal">
        一是雪茄文化。对其进行“体验营销”，挖掘雪茄产业链中可紧密对接受众的环节，打造立体参与式消费场景，为受众提供“抽雪茄”、“制作雪茄”等独特体验，并在短视频即时记录、传播的特点下激发受众更大的参与意愿；
      </p>
      <p class="ArticleNormal">
        二是美食文化。对什邡板鸭、红白豆腐、肖麻辣、王饼子、蒋妈冰粉等什邡特色美食进行特色旅游产品开发，挖掘其创意传播的元素，充分发挥食用性与体验性兼具的功能。通过食客个人的表演和短视频的聚焦、传播，使观众产生好奇心，激发体验欲望，吸引更多人前往什邡“打卡”；
      </p>
      <p class="ArticleNormal">
        三是历史文化。什邡是四川省历史文化名城，是佛教南禅八祖马道一的故里，汉代名将雍齿的受封之地。李冰文化、佛教文化等历史文化中有着丰富的旅游景点，为塑造成为短视频传播中的“网红”提供了多样的素材。可与各历史景点的特色与文化内涵相结合，打造视觉冲击力强的文化艺术类活动、植入创意艺术装置等，吸引受众观看并通过短视频记录、分享，营造城市处处是“网红”的全新面貌。
      </p>
      <p class="ArticleNormal">
        此外，什邡的蓥华山、青牛沱、雍湖公园、蓥华镇、师古镇等旅游资源，以及地震文化、感恩文化、农耕文化等特色文化品牌也有丰富的符号可进行提炼、创作，形成短视频传播的创意素材，进一步提升什邡的吸引力与美誉度。
      </p>
      <p class="ArticleHead">
        因地制宜打造“网红象山”名片
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">【应建勇 象山县委常委、宣传部长】</span>
      </p>
      <p class="ArticleNormal">
        当前，媒介技术的发展引发城市形象传播的变革。现阶段，短视频这种新技术、新载体、新平台扩充了原有的城市符号，大大增强了人与城市的联系。作为县域城市，浙江省宁波市象山县借助短视频平台构建和传播了独特的“象山名片”，塑造了更加立体多元的“象山形象”。短视频也因此成为了我们在互联网时代进行城市传播、助力城市能级提升的一个全新选项。
      </p>
      <p class="ArticleNormal">
        因时求变，迎着风口构建新传播生态。近年来，以抖音为代表的短视频社交软件几乎一夜走红。简便快捷的操作、自由个性的表达以及低门槛、易模仿等优点，使得短视频迅速吸引了庞大的流量。时代打开了前所未有的机遇窗口，在“互联网+”的融合变革中，在特殊时期里，有更多城市正在以短视频、互动话题等年轻态传播形式，打造全新城市IP形象。
      </p>
      <p class="ArticleNormal">
        将短视频传播思维贯穿到城市的宣传理念，能在很短时间内提高曝光率和知名度，吸引外地游客、拉动产业发展、促进商贸繁荣，继而产生巨大的经济社会价值。象山县将主动拥抱短视频兴起带来的传播形态和传播生态新变化，引领政府、市民、游客等自觉参与到城市名片的构建中来，让城市传播从政府为主体的宣传转换到构建双循环传播体系，主流媒体主流叙事和市民为主体的自发创作耦合，全面立体地展现象山风貌、传播象山形象。
      </p>
      <img src="../../../assets/1st/Articles/Article_2/contant_9.jpg"/>
      <p class="ArticleNormal">
        因地制宜，打造别具海洋特色“网红象山”。象山是长三角著名的海洋旅游胜地，文化底蕴深厚，拥有北纬30度中国“最美海岸线”，旖旎的海岸风光，鲜美的源头海鲜，纯朴的渔乡风情等都是象山独特的城市符号。以中国（象山）开渔节为例，今年的开渔节正在通过短视频和直播等传播形式，让更多城市的“网红基因”得以被挖掘和扩散，让传统的文旅品牌有机更新。
      </p>
      <p class="ArticleNormal">
        作为著名的滨海城市，象山每年一届举行的“开渔节”开创了中国独一无二的海洋庆典活动，具有浓郁的渔乡风情和海滨旅游特色。而今年的“开渔节”也别有风味，安排了线上线下二十几项活动，既有神圣、神秘、神奇的传统“祭海、开船”仪式，也有动感、动态、动人的“开渔之旅”“渔钓东海·我为泥狂”等时尚活动，还有别开生面的“抖音开渔”“天猫抓鱼”、乡贤明星“云祝愿”等线上活动，为全国游客呈现一席别样精彩、独具韵味的开渔盛宴。正是通过借助抖音、今日头条等平台进行线上创意传播和用户深度种草，我们不仅实现了对海洋文化的创意输出和沉淀，同时也有效提升了城市品牌形象与知名度。
      </p>
      <p class="ArticleNormal">
        因势而谋，拓展传播带宽赋能城市繁荣。当前，象山正处在转型换挡、爬坡上行的关键阶段，发展是象山最大的任务。拓宽短视频传播的领域、内涵、外延，将有助于推动象山发展，助力象山“快追赶、攀新高”。
      </p>
      <p class="ArticleNormal">
        但同时，我们也清醒认识到，在依托短视频打造“网红象山”的过程中，要避免为了一个个流量“陷阱”而自乱阵脚，甚至放弃底线。我们需要为主流叙述带来流量“活力”，但是更需要以信仰、信念、信心为魂，保持主流传播的“定力”。要让政府定义城市形象，制造和推动热点，让普通群众参与相关内容创作成为城市形象的具体阐述者，不断推动城市形象的转变与构建，最终直接转化为具体的效益，助推象山发展。同时，还要通过短视频打造并传播“网红事迹”、“网红人物”，将正能量转化为大流量，引导55万象山人民汇集凝心聚力谋发展的澎湃精神力量。
      </p>
      <p class="ArticleNormal">
        可以说，短视频助力城市宣传从硬推广过渡到软传播，实现了城市附加值和竞争力的提升，进而推动了地区经济的发展，为象山实现“弯道超车”带来了前所未有的机遇。我们将持之以恒地深入挖掘、准确把握、合理利用各方资源，为象山“聚力一二五、奋力上台阶”，实现“快追赶、攀新高”提供强大的舆论支持和精神动力。
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">结语</span>
      </p>
      <p class="ArticleNormal">
        每个城市有着自己独特的历史文明、人文风貌与发展路径，但不是所有城市都能在一夜之间成为“网红”。城市围绕自身特色对短视频内容传播进行有节奏、有针对性的长线化运营尤为重要。从设计城市名片伊始，到传播落地带来效果转化，这个过程涉及诸多环节，也需要多方努力。
      </p>
      <p class="ArticleNormal">
        为了更好地协调城市在名片打造过程中的各个环节分工以及统筹城市品牌形象传播的节奏，一套可以指导城市传播实践、引导行业趋势的有效的评估体系格外重要。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article2"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article2.vue